/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_Merge_Display_Name_PlaceholderInputs */

const en_translation_merge_display_name_placeholder = /** @type {(inputs: Translation_Merge_Display_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Display Name`)
};

const fr_translation_merge_display_name_placeholder = /** @type {(inputs: Translation_Merge_Display_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom d'affichage`)
};

const de_translation_merge_display_name_placeholder = /** @type {(inputs: Translation_Merge_Display_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzeigename`)
};

const it_translation_merge_display_name_placeholder = /** @type {(inputs: Translation_Merge_Display_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome da visualizzare`)
};

const ru_translation_merge_display_name_placeholder = /** @type {(inputs: Translation_Merge_Display_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отображаемое имя`)
};

const es_translation_merge_display_name_placeholder = /** @type {(inputs: Translation_Merge_Display_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre para mostrar`)
};

const zh_cn2_translation_merge_display_name_placeholder = /** @type {(inputs: Translation_Merge_Display_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`显示名称`)
};

const ja_translation_merge_display_name_placeholder = /** @type {(inputs: Translation_Merge_Display_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表示名`)
};

const hi_translation_merge_display_name_placeholder = /** @type {(inputs: Translation_Merge_Display_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रदर्शित होने वाला नाम`)
};

const pt_pt2_translation_merge_display_name_placeholder = /** @type {(inputs: Translation_Merge_Display_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome de exibição`)
};

/**
* | output |
* | --- |
* | "Display Name" |
*
* @param {Translation_Merge_Display_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_merge_display_name_placeholder = /** @type {((inputs?: Translation_Merge_Display_Name_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Merge_Display_Name_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_translation_merge_display_name_placeholder(inputs)
	if (locale === "de") return de_translation_merge_display_name_placeholder(inputs)
	if (locale === "it") return it_translation_merge_display_name_placeholder(inputs)
	if (locale === "ru") return ru_translation_merge_display_name_placeholder(inputs)
	if (locale === "es") return es_translation_merge_display_name_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_translation_merge_display_name_placeholder(inputs)
	if (locale === "ja") return ja_translation_merge_display_name_placeholder(inputs)
	if (locale === "hi") return hi_translation_merge_display_name_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_translation_merge_display_name_placeholder(inputs)
	return en_translation_merge_display_name_placeholder(inputs)
});